/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="validationerrormessageresolverservice.ts" />
/// <reference path="usermessagesservice.ts" />
/// <reference path="globalsettingsservice.ts" />

module App.Common.Services {
	'use strict';

	export class FormHelperService {

		public static $inject = ['app.common.services.globalSettingsService'];

		constructor(private globalSettings: Services.GlobalSettingsService) {
			this.mainFormName = globalSettings.mainFormName;
		}

        public mainFormName: string;
        public subFormName: string;

		public mainFormElement(): angular.IAugmentedJQuery {
			const el = angular.element($(`form[name=${this.mainFormName}]`));
			return el.length ? el : null;
        }

        public subFormElement(): angular.IAugmentedJQuery {
            const el = angular.element($(`ng-form[name=${this.subFormName}]`));
            return el.length ? el : null;
        }

		public mainFormScope(): angular.IScope {
			const el = this.mainFormElement();
			if (!el) {
				return null;
			}
			return el.scope();
        }

        public subFormScope(): angular.IScope {

            const el = this.subFormElement();
            if (!el) {
                return null;
            }
            return el.scope();
        }

		public mainForm(): angular.IFormController {
			const scope = this.mainFormScope();
			if (!scope) {
				return null;
			}
			return scope[this.mainFormName];
        }

        public subForm(name: string): angular.IFormController {

            this.subFormName = name;
            const scope = this.subFormScope();
            if (!scope) {
                return null;
            }
            return scope[this.subFormName];
        }

		public input(name: string) {
			const form = this.mainForm();
			if (!form) {
				return null;
			}
			return form[name];
		}

		public inputElement(name: string) {
			const el = this.mainFormElement();
			if (!el) {
				return null;
			}
			return el.find(`[name=${name}]`);
        }
        public getFormController(formName: string): angular.IFormController {
            const el = angular.element($(`form[name=${formName}]`));
            if (el.length) {
                if (el.scope()) {
                    return el.scope()[formName];
                }
                return null;
            }
            return null;
        }

	}

	angular
		.module('app.common.services')
		.service('app.common.services.formHelperService', FormHelperService);
}